<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <span class="box-title" v-bind:class="{ h2: boldTitle === 'true' }">{{
          name | capitalize
        }}</span>
      </div>
      <div class="col-md-6 text-right" v-if="fullview">
        <AirbnbDatePicker module="dashboard"></AirbnbDatePicker>
      </div>
    </div>
    <div class="row text-center">
      <div class="col-xs-12 col-md-12 text-center px-0">
        <canvas class="full-height" :id="name" :height="height"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from '@/store'
const AirbnbDatePicker = () => import('@/components/AirbnbDatePicker.vue')
import format from 'date-fns/format'

require('../../../static/js/dashboard.js')

/* eslint-disable */
export default {
  store,
  props: [
    'name',
    'groupby',
    'mapUnit',
    'showPercent',
    'height',
    'boldTitle',
    'clearState',
    'fullview',
  ],
  components: {
    AirbnbDatePicker,
  },
  mounted() {
    this.loadData()
  },
  watch: {
    stats: function () {
      this.loadData()
    },
    '$store.getters.datepicker.dashboard': {
      handler: function (date) {
        this.startDate = date.startDate
        this.endDate = date.endDate
        this.changePeriod()
      },
      deep: true,
    },
    '$store.getters.faces': {
      handler: function (value) {
        this.loadData()
      },
    },
  },
  methods: {
    loadData: function () {
      this.$http
        .post(process.env.API_ENDPOINT + '/report/columnchart', {
          company_id: this.$session.get('company_id'),
          branch_id: 0,
          source_id: 0,
          option: this.columnOption,
          groupby: this.groupby,
          rank: this.$store.getters.faces,
          startDate: this.$store.getters.datepicker.dashboard.startDate,
          endDate: this.$store.getters.datepicker.dashboard.endDate,
        })
        .then((response) => {
          this.processData(response)
          this.loadChart()
          this.clearState = false
        })
    },
    changePeriod: function (value) {
      this.columnOption = value
      this.clearState = true
      this.loadData()
      this.clearState = false
    },
    processData: function (response) {
      var vgList = []
      var vbList = []
      var gList = []
      var bList = []

      var groupdata = {
        labels: [],
        datasets: [],
      }
      // Initiate
      var data = {}

      for (let i in response.data) {
        let current = response.data[i]
        var unit = current.unit

        if (data[unit] === undefined) {
          data[unit] = {}
        }
        if (data[unit][current.rank_id] === undefined) {
          data[unit][current.rank_id] = 0
        }
        data[unit][current.rank_id] += current.total
      }

      if (this.groupby !== 'date') {
        // fill in the blanks
        var max = 0
        var min = 10
        for (let property in data) {
          max = max < parseFloat(property) ? parseFloat(property) : max
          min = min > parseFloat(property) ? parseFloat(property) : min
        }

        for (let i = min; i <= max; i++) {
          if (data[i] === undefined) {
            data[i] = {}
          }
        }
      }

      for (let i in data) {
        // Loop through the week
        let current = data[i]
        if (!groupdata.labels.includes(this.nameMapping(i)))
          groupdata.labels.push(this.nameMapping(i))

        var vb = current[4] ? current[4] : 0
        var b = current[3] ? current[3] : 0
        var g = current[2] ? current[2] : 0
        var vg = current[1] ? current[1] : 0

        if (this.percentageView) {
          var max = vb + b + g + vg
          vb = this.precisionRound((vb / max) * 100, 2)
          b = this.precisionRound((b / max) * 100, 2)
          g = this.precisionRound((g / max) * 100, 2)
          vg = this.precisionRound((vg / max) * 100, 2)
        }

        vbList.push(vb)
        bList.push(b)
        gList.push(g)
        vgList.push(vg)
      }

      var bestDay = 0
      var worstDay = 0
      var score = 0
      var previousBest = 0
      var previousWorst = 0
      var total = []

      // intend to find best and worst performing day.
      for (let i in groupdata.labels) {
        score = vgList[i] + gList[i] * 3 + bList[i] * -4 + vbList[i] * -7
        if (i == 0) {
          bestDay = worstDay = 1
          previousBest = previousWorst = score
        }

        if (score > previousBest) {
          bestDay = i
          previousBest = score
        }
        if (score < previousWorst) {
          worstDay = i
          previousWorst = score
        }

        total.push(vgList[i] + gList[i] + bList[i] + vbList[i])
      }

      this.$emit('callback', {
        best: groupdata.labels[bestDay],
        worst: groupdata.labels[worstDay],
      })

      this.$emit('data', {
        label: groupdata.labels,
        vg: vgList,
        g: gList,
        b: bList,
        vb: vbList,
        total: total,
      })

      groupdata.datasets.push(
        {
          label: 'Very Bad',
          data: vbList,
          backgroundColor: 'rgb(255, 75, 57)',
        },
        {
          label: 'Bad',
          data: bList,
          backgroundColor: '#f7c000',
        },
        {
          label: 'Good',
          data: gList,
          backgroundColor: '#00ac7d',
        },
        {
          label: 'Very Good',
          data: vgList,
          backgroundColor: '#059ab2',
        }
      )
      // {
      //   label: 'Good',
      //   data: gList,
      //   backgroundColor: '#a2cb48'
      // },
      // {
      //   label: 'Very Good',
      //   data: vgList,
      //   backgroundColor: '#00ac7d'
      // })
      let storeData = {
        name: this.name,
        data: groupdata,
      }

      this.$store.commit('setColumnChart', storeData)
    },
    loadChart: function () {
      let groupdata = this.$store.getters.columnChart[this.name]

      if (this.chart !== undefined) this.chart.destroy()
      let chartData = {
        type: 'bar',
        data: groupdata,
        options: {
          onClick: function (evt, item) {
            if (item[0]) {
              let clicked = item[0]['_model'].label
              console.log(clicked)
            }
          },
          legend: {
            display: false,
          },
          scales: {
            xAxes: [
              {
                ticks: {
                  autoSkip: true,
                  maxRotation: 0,
                },
                stacked: true,
                categoryPercentage: 0.9,
                barPercentage: 0.75,
              },
            ],
            yAxes: [
              {
                stacked: true,
              },
            ],
          },
          defaultFontSize: 16,
          layout: {
            padding: {
              top: 30,
            },
          },
        },
      }
      if (this.showPercent) {
        chartData.options.scales.yAxes[0].ticks = {
          max: 100,
          beginAtZero: true,
          stepValue: 10,
        }
      }

      let ctx = document.getElementById(this.name)
      import('chart.js').then(Chart => {
        this.chart = new Chart(ctx, chartData) // eslint-disable-line no-new
      })
    },
    precisionRound: function (number, precision) {
      var factor = Math.pow(10, precision)
      return Math.round(number * factor) / factor
    },
    hourName: function (hour) {
      let part1 = hour % 12 || 12 // Adjust hours
      let part2 = hour < 12 ? 'am' : 'pm' // Set AM/PM
      return part1 + part2
    },
    weekName: function (day) {
      let name = ''
      day = parseInt(day)
      switch (day) {
        case 1:
          name = 'Sun'
          break
        case 2:
          name = 'Mon'
          break
        case 3:
          name = 'Tue'
          break
        case 4:
          name = 'Wed'
          break
        case 5:
          name = 'Thu'
          break
        case 6:
          name = 'Fri'
          break
        case 7:
          name = 'Sat'
          break
      }
      return name
    },
    dateFormat: function (date) {
      return format(date, 'D MMM')
    },
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
  },
  data: function () {
    return {
      columnOption: 'all',
      nameMapping: eval('this.' + this.mapUnit),
      percentageView: this.showPercent,
      chart: undefined,
      clearState: false,
      startDate: '',
      endDate: '',
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/ColumnChart.vue